<template>
  <div>
    <el-button class="newAdd" @click="openDialog" size="mini">管理</el-button>
    <el-dialog
      title="管理"
      :visible.sync="moveDialogVisible"
      width="40%"
      center
      @close="clear"
    >
      <el-form :model="form" :rules="rules" ref="form">
        <el-form-item
          label="用户UID"
          :label-width="formLabelWidth"
          prop="inviteBy"
        >
          <el-input
            v-model="form.inviteBy"
            class="searchIpt"
            autocomplete="off"
            type="textarea"
            :rows="5"
            placeholder="多个uid请以英文逗号或空行隔开"
            maxlength="50"
            show-word-limit
          ></el-input>
        </el-form-item>
        <el-form-item label="针对模块" :label-width="formLabelWidth">
          <el-select
            v-model="form.type"
            placeholder="请选择针对模块"
            clearable
            :style="{ width: '100%' }"
          >
            <el-option
              v-for="(item, index) in typeOptions"
              :key="index"
              :label="item.label"
              :value="item.value"
              :disabled="item.disabled"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          label="备注"
          :label-width="formLabelWidth"
          prop="inviteBy"
        >
          <el-input
            v-model="form.inviteBy"
            class="searchIpt"
            autocomplete="off"
            type="textarea"
            :rows="5"
            placeholder="备注"
            maxlength="50"
            show-word-limit
          ></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="mini" type="primary" @click="clear">关闭</el-button>
        <el-button size="mini" type="primary" @click="add">拉白</el-button>
        <el-button size="mini" type="primary" @click="add">拉黑</el-button>
        <!-- <el-button size="mini" @click="clearFiled">重置</el-button> -->
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import moment from 'moment'
import { LANGARR, FINDLANGARR } from '../../constants'
export default {
  data() {
    return {
      moveDialogVisible: false,
      detailInfo: null,
      isAct: false,
      form: {
        inviteBy: '',
        userId: '',
        rate: '',
        remark: '',
        lang: [],
        coin: 0,
      },
      taskForm: {
        inviteBy: '',
        userId: '',
        rate: '',
        remark: '',
        lang: [],
      },
      langArr: LANGARR,
      formLabelWidth: '80px',
      rules: {
        userId: [{ required: true, message: '请输入UID', trigger: 'blur' }],
        inviteBy: [
          { required: true, message: '请输入合伙人UID', trigger: 'blur' },
        ],
        rate: [{ required: true, message: '请输入比例', trigger: 'blur' }],
        otcRate: [
          { required: true, message: '请输入otcRate返佣比例', trigger: 'blur' },
        ],
      },
      taskRules: {
        userId: [{ required: true, message: '请输入UID', trigger: 'blur' }],
        inviteBy: [
          { required: true, message: '请输入合伙人UID', trigger: 'blur' },
        ],
        rate: [{ required: true, message: '请输入比例', trigger: 'blur' }],
        otcRate: [
          { required: true, message: '请输入otcRate返佣比例', trigger: 'blur' },
        ],
      },
      currentLang: '',
      typeOptions: [
        {
          label: '普通账户',
          value: 0,
        },
        {
          label: '量化账户',
          value: 1,
        },
        {
          label: '风险保证金账户',
          value: 2,
        },
      ],
      userOptions: [
        {
          label: '普通账户',
          value: 0,
        },
        {
          label: '量化账户',
          value: 1,
        },
        {
          label: '风险保证金账户',
          value: 2,
        },
      ],
      rewardOptions: [
        {
          label: '奖励金-10USDT',
          value: 0,
        },
      ],
      taskContentOptions: [
        {
          label: 'AND',
          value: 0,
        },
        {
          label: 'OR',
          value: 1,
        },
      ],
      taskContentOptions1: [
        {
          label: '入金充值',
          value: 0,
        },
        {
          label: '永续合约交易体验',
          value: 1,
        },
      ],
      taskContentOptions2: [
        {
          label: '单次金额达成',
          value: 0,
        },
        {
          label: '累计金额达成',
          value: 1,
        },
      ],
      coinOptions2: [
        {
          label: 'USDT',
          value: 0,
        },
      ],
      addTaskArr: 1,
    }
  },
  methods: {
    ...mapActions('partnerList', ['addPartner', 'getUserData']),
    FINDLANGARR,
    changeCurrentLang(value) {
      this.currentLang = value
    },
    setCurrentLang(item) {
      this.currentLang = this.form.lang[0]
    },
    handleAddTask() {
      this.addTaskArr++
    },
    handleDelTask() {
      this.addTaskArr == 0 ? (his.addTaskArr = 0) : this.addTaskArr--
    },
    openDialog() {
      this.moveDialogVisible = true
    },

    add() {
      this.$refs['form'].validate((valid) => {
        if (valid) {
          this.addPartner(this.form).then((res) => {
            if (res.code == 0) {
              this.$message.success('添加成功')
              this.$emit('refresh')
              this.clear()
            } else {
              this.$message.error('添加失败')
              this.clear()
            }
          })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    clearFiled() {
      this.$refs['form'].resetFields()
    },
    clear() {
      this.moveDialogVisible = false
      this.$refs['form'].resetFields()
    },
  },
}
</script>

<style lang="less" src="@/styles/button.less" scoped>
.content {
  // border: 1px solid #f5f6f7;
  padding: 20px;
  width: 100%;
  height: 200px;
  .up {
    border: 1px solid #f5f6f7;
    width: 100%;
    height: 50%;
    display: flex;
  }
  .down {
    border: 1px solid #f5f6f7;
    width: 100%;
    height: 50%;
    display: flex;
    justify-content: space-around;
    align-items: center;
  }
  .item {
    border-right: 1px solid #f5f6f7;
    display: flex;
    width: 50%;
    height: 100%;
    justify-content: center;
    align-items: center;
    .ipt {
      width: 90%;
    }
  }
}
.btn1 {
  display: flex;
  justify-content: center;
  width: 300px;
  margin: 0 auto;
}
</style>
<style lang="less" scoped>
.langTab {
  cursor: pointer;
  margin-right: 20px;
  display: inline-block;
}
.task {
  border: 1px solid #000;
  padding: 12px;
}

.flex {
  display: flex;
  gap: 12px;
  align-items: center;
}
.addTask {
}
</style>
